module.exports = __webpack_public_path__ + "static/media/lounge-logo.2ae68d20.svg";